import TableCell from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { MenuItem, Select } from '@mui/material';

import * as React from 'react';


const StyledTableCell = styled(TableCell)({
    padding: 0,
})  

export const NOTICE_TABLE_CONSTANTS = (updateAssignmentStatus, ASSIGNMENT_OPTIONS, activeUser) =>{ 
    
    return [
        { field: 'Accountnumber', headerName: 'Account #', flex: 1, minWidth: 85 },
        { field: 'Unit', headerName: 'Unit', flex: 1, minWidth: 85 },
        { field: 'City', headerName: 'City', flex: 1, minWidth: 85 },
        { field: 'zip', headerName: 'Postal Code', flex: 1, minWidth: 85 },
        {field: 'zip7', headerName: 'Neighborhood', flex: 1, minWidth: 125},
        { 
            field: 'assigned_to', 
            headerName: 'Assigned To', 
            flex: 1,
            minWidth: 200,
            renderCell: (params) => {
                return (
                    <Select
                        variant='standard'
                        size="small"
                        value={params.value || ''}
                        onChange={async (event) => {
                            const newValue = event.target.value;
                            try {
                                const response = await updateAssignmentStatus(params.row, newValue);
                                if (response.ok) {
                                    params.api.updateRows([{
                                        id: params.id,
                                        status_text: newValue
                                    }]);
                                } else {
                                    console.error('Failed to update status');
                                }
                            } catch (error) {
                                console.error('Error updating status:', error);
                            }
                        }}
                        fullWidth
                    >
                        {ASSIGNMENT_OPTIONS.map(option => (
                            (activeUser.admin === 1) && (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.email.split("@")[0]}
                                </MenuItem>
                            )
                            ))
                        }
                    </Select>
                )
        }
        },
    ];
}